import { 
  Building2, Building, Globe, ShieldCheck, Cpu, 
  FileEdit, AlertCircle, Hash, CalendarCheck,
  Info, Target, HelpCircle, Handshake, MessageCircle,
  FileBadge
} from 'lucide-react';
import { NavItem, SubItem } from './types';

export const WHATSAPP_NUMBER = "966566900924";

export const getWAUrl = (service: string) => 
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(`السلام عليكم، أرغب في الاستفسار عن خدمة ${service}`)}`;

export const services: SubItem[] = [
  { name: 'تأسيس الشركات', href: '/services/company-formation', icon: Building2, description: 'تأسيس شامل للكيانات القانونية والشركات ذات المسؤولية المحدودة' },
  { name: 'السجل التجاري', href: '/services/commercial-register', icon: FileBadge, description: 'إصدار، تجديد، وشطب وتعديل السجلات وحوكمة الأنشطة' },
  { name: 'الاستثمار الأجنبي', href: '/foreign-investor-setup', icon: Globe, description: 'تراخيص وزارة الاستثمار MISA وتسهيل دخول السوق السعودي' },
  { name: 'التراخيص الحكومية', href: '/services/licensing', icon: ShieldCheck, description: 'استخراج التراخيص والموافقات من الهيئات والوزارات الحكومية' },
  { name: 'التحول الرقمي', href: '/services/digital-transformation', icon: Cpu, description: 'ربط وإدارة المنصات الإلكترونية: قوى، مقيم، ومدد للشركات' },
  { name: 'رفع تعليق السجل', href: getWAUrl('رفع تعليق السجل'), icon: AlertCircle, description: 'معالجة فورية للمخالفات وحلول سريعة لفك تجميد الأنشطة' },
  { name: 'حجز اسم تجاري', href: getWAUrl('حجز اسم تجاري'), icon: Hash, description: 'حجز ومطابقة الأسماء التجارية المناسبة وفق ضوابط الوزارة' },
];

export const aboutLinks: SubItem[] = [
  { name: 'هويتنا وفلسفتنا', href: '#about', icon: Info, description: 'تعرف على قيمنا ورسالتنا الريادية في خدمة المستثمرين' },
  { name: 'ما يميزنا', href: '#why-us', icon: HelpCircle, description: 'أسباب تجعلنا الشريك الموثوق لتأسيس وتنمية أعمالك في المملكة' },
  { name: 'كيف نعمل', href: '#process', icon: Target, description: 'منهجيتنا المدروسة من الاستشارة الأولى وحتى انطلاق الأعمال' },
  { name: 'نجاحات التأسيس', href: '#partners', icon: Handshake, description: 'معرض لشركاء النجاح والكيانات التي ساهمنا بتأسيسها' },
];

export const navItems: NavItem[] = [
  { name: 'الرئيسية', href: '/' },
  { name: 'عن الشركة', href: '/about', hasDropdown: true, subItems: aboutLinks },
  { name: 'خدماتنا', href: '/services', hasDropdown: true, subItems: services },
  { name: 'احجز استشارة مجانا', href: '/contact' },
];

export const allSearchableItems: SubItem[] = [
  ...services.map(s => ({ ...s, type: 'خدمة' })),
  ...aboutLinks.map(a => ({ ...a, type: 'عن الشركة' })),
  { name: 'الأسئلة الشائعة', href: '#faq', icon: HelpCircle, type: 'معلومات' },
  { name: 'احجز استشارة مجانا', href: '#contact', icon: MessageCircle, type: 'تواصل' },
];
